<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="m22.56 13.66-1.9-6.83a9.32 9.32 0 0 0-18.08.47L1.1 13.91A5 5 0 0 0 5.99 20H7.1a5 5 0 0 0 9.8 0h.84a5 5 0 0 0 4.82-6.34M12 22a3 3 0 0 1-2.82-2h5.64A3 3 0 0 1 12 22m8.13-5.18a3 3 0 0 1-2.4 1.18H6a3 3 0 0 1-2.93-3.65l1.47-6.62a7.32 7.32 0 0 1 14.2-.37l1.9 6.84a3 3 0 0 1-.5 2.62"/></svg>
</template>
